import { render, staticRenderFns } from "./HomeCategorySlider.vue?vue&type=template&id=240a8239"
import script from "./HomeCategorySlider.vue?vue&type=script&lang=js"
export * from "./HomeCategorySlider.vue?vue&type=script&lang=js"
import style0 from "./HomeCategorySlider.vue?vue&type=style&index=0&id=240a8239&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports